import GlobeStrikethroughIcon from '@atlaskit/icon-lab/core/globe-strikethrough';
import * as React from 'react';

export function SvgPublicOff() {
  return <GlobeStrikethroughIcon label="" testId="ads-refreshed-icon" />;
}
